import React, {PureComponent} from 'react';

import {getJwt} from '../../services/authService';
import http from '../../services/httpService';
import InputRegular from '../common/InputRegular';
import Header from './Header';
import ReactGA from "react-ga";
import toastr from "toastr";

class ForgotPassword extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {

            spinnerActive: false,
            data: {
                email: "",

            },
            errorsList: [],
            fieldsCheckActive: false
        };
    }

    componentDidMount() {
       // ReactGA.pageview(window.location.pathname + window.location.search);

    }

    doSubmit = async () => {
        await this.setState({fieldsCheckActive: true})
        setTimeout(async () => {
            let anyErrorActive = false;
            await this.state.errorsList.map(async (error) => await error ? anyErrorActive = true : '')
            if(!anyErrorActive && this.state.data.email){
                try {
                    await this.setState({ spinnerActive: true });
                    const result = await http.post('/api/forgotten-password', { email: this.state.data.email }, { headers: { authorization: getJwt() } });
                    this.props.history.push('/recovery-sent');
                } catch(ex) {
                    //console.log('le wild error has appeared');
                    this.setState({ spinnerActive: false });
                    toastr.error('Error with sending recovery email')
                }
            }
        },500);
    };

    updateErrorsList = async (error, id) => {
        let errorsList = await this.state.errorsList;
        errorsList[parseInt(id) - 1] = await error;
        await this.setState({errorsList})
        // console.log('errorsList: ', errorsList)
    }



    render() {

        return (
            <div className='onboarding-container'>
                <Header linkDisabled={true}/>
                <div className="onboarding-content reset-pass-container">
                    <div className="onboarding-panel">
                        <h1 className='onboarding-title'>Forgot password?</h1>
                        <InputRegular
                            id="1"
                            label1="Enter your email"
                            label2=""
                            placeholder=""
                            type='email'
                            onChange={ e => this.setState({data:{ email: e }}) }
                            value={this.state.data.email}
                            updateErrorsList={this.updateErrorsList}
                            errorMessage="Must be a valid email address"
                            fieldsCheckActive={this.state.fieldsCheckActive}
                            required={true}
                        />
                        { !this.state.spinnerActive ?
                            <button className="btn-action" onClick={ this.doSubmit }>Confirm</button>
                            :
                            <button className="btn-action btn-spinner" onClick={ this.doSubmit }>Confirm <i className='fa fa-spin fa-spinner'></i></button>
                        }
                    </div>
                </div>
            </div>
        )
    }

}

export default ForgotPassword